
define('views/payment-page-view',[
  'jquery',

  'modules/cart-actions',

  'views/quick-cart',
  'views/process-options',

  'connections/cart-connection',

  'utils/view',
  'utils/form-validator',
  'utils/tooltip-init',
  'utils/pikaday-i18n',
  'utils/debounce',
  'utils/validate-box-items',
  'pikaday',
  'settings'
], function (
  $,
  CartActions,
  QuickCart,
  ProcessOptions,
  CartConnection,
  View,
  FormValidator,
  tooltipInit,
  pikadayi18n,
  debounce,
  validateBoxItems,
  Pikaday,
  settings
) {
  var _this;
  var PaymentPageView = (function () {
    function PaymentPageView() {
      _this = this;
    }


    /**
     * Initializes the cart bindings.
     *
     * @method _init
     * @private
     */
    PaymentPageView.prototype._init = function () {

      if (typeof AdyenCheckout !== "undefined") {
        this.initAdyenPayments();
      }
    };



    PaymentPageView.prototype.makePayment = function (data, clientOrderNumber) {
      return _this.postData(data, clientOrderNumber);
    };

    PaymentPageView.prototype.makeDetailsCall = function (data, clientOrderNumber) {
      data = data || {};
      return CartConnection.adyenMakeDetailsCall(data, clientOrderNumber);
    };

    PaymentPageView.prototype.postData = function (data, clientOrderNumber) {
      data = data || {};
      return CartConnection.adyenMakePayment(data, clientOrderNumber);
    };

    PaymentPageView.prototype.getAdyenPaymentMethods = function () {

      return CartConnection.getAdyenPaymentMethods()
        .then(function (res) {
          return res;
        });
    };

    PaymentPageView.prototype.getLocale = function () {

      return CartConnection.getShopperLocale()
        .then(function (res) {
          return res;
        });
    };

    PaymentPageView.prototype.initAdyenPayments = function () {
      this.getLocale().then(function (response) {
        _this.getAdyenPaymentMethods().then(function (response2) {
          var paymentMethods = JSON.parse(response2);
          var configuration = _this.setConfiguration(response.locale, paymentMethods);
          var checkout = new AdyenCheckout(configuration);
          if ($("#dropin-container").length)
            var dropin = checkout.create('dropin').mount('#dropin-container');
        });
      });
    };

    PaymentPageView.prototype.setConfiguration = function (locale, paymentMethods) {

      return {
        paymentMethodsResponse: paymentMethods, // The paymentMethods response from the server.

        locale: locale,//"sv-SE",
        environment: settings.adyenEnvironment.toLowerCase(),
        clientKey: settings.adyenClientKey,
        onSubmit: function (state, dropin) {
          var adyenDropin = dropin;
          adyenDropin.setStatus('loading'); // start the loading state
          var clientOrderNumber = document.getElementById('ClientOrderNumber').value;
          // Your function calling your server to make the `/payments` request
          _this.makePayment(state.data, clientOrderNumber).then(function (response) {
            _this.setResponseToDropin(response, adyenDropin);
          });
          // .catch(function (error) {
          //   throw Error(error);
          // });
        },
        onError: function (error) {
          //$('#adyenErrorContainer').text(error);
        },
        onAdditionalDetails: function (state, dropin) {
          var adyenDropin = dropin;
          adyenDropin.setStatus('loading'); // start the loading state
          // Your function calling your server to make a `/payments/details` request
          var clientOrderNumber = document.getElementById('ClientOrderNumber').value;
          _this.makeDetailsCall(state.data, clientOrderNumber)
            .then(function (response) {
              _this.setResponseToDropin(response, adyenDropin);
            });
          // .catch(function (error) {
          //   throw Error(error);
          // }
          // );
        },
        paymentMethodsConfiguration: {
          card: { // Example optional configuration for Cards
            hasHolderName: true,
            holderNameRequired: true,
            enableStoreDetails: true,
            hideCVC: false, // Change this to true to hide the CVC field for stored cards
            name: 'Credit or debit card',
            //billingAddressRequired: true
          }
        }
      };
    };

    PaymentPageView.prototype.setResponseToDropin = function (response, adyenDropin) {
      if (!response.success) {
        adyenDropin.setStatus('ready');
        errorText = response.responseText;
        $('#adyenErrorContainer').text(errorText);
        return;
      }

      var responseObject = JSON.parse(response.message);
      if (responseObject.action) {
        // Drop-in handles the action object from the /payments response
        adyenDropin.handleAction(responseObject.action);
      } else {
        // Your function to show the final result to the shopper

        if (responseObject == null)
          errorText = 'Unknown payment error';


        switch (responseObject.resultCode) {
          case "Authorised":
            document.getElementById('PspReference').value = responseObject.pspReference;
            $('#sendCreateErpOrder').submit();
            return;
          case "Error":
            errorText = "There was an error processing your payment.";
            break;
          case "Refused":
            //Todo add refusal reasons
            errorText = "The payment was refused. Try the payment again using a different payment method or card.";
            break;
          case "Pending":
            errorText = "We've received their order, and are waiting for the payment to be completed.";
            break;
          case "Received":
            errorText = "We've received their order, and are waiting for the payment to clear.";
            break;
          default:
            errorText = "Unknown error.";
        }
        // Show an error message
        // dropin.setStatus('error');
        // dropin.setStatus('error', { message: errorText });
        adyenDropin.setStatus('ready');
        $('#adyenErrorContainer').text(errorText);
      }
    };

    PaymentPageView.prototype.validateInput = function (e, blockOverlayLoader) {
      var isValidForm = _this.formValidator.validateForm();
      var isValidPO = true;
      if (_this.PO) isValidPO = _this.PO.validateProcessOptions();

      if (!isValidForm || !isValidPO) {
        $('#placeOrderButton').addClass('button--error');
        $('.adyen-checkout__button').addClass('button--error');
        return false;
      } else if (!blockOverlayLoader) {
        _this.showOverlayLoader();
      }
      return true;
    };

    return PaymentPageView;
  })();

  return View('PaymentPageView', function () {
    var cv = new PaymentPageView();
    cv._init();
  });
});

